import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ComparisonSection from './components/ComparisonSection';
import SolutionsSection from './components/SolutionsSection';
import TrustSection from './components/TrustSection';
import FAQSection from './components/FAQSection';
import ArticleTeaser from './components/ArticleTeaser';

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "VigorBuy Spreadsheet",
  "url": "https://vigorbuyspread.cyou",
  "description": "The Complete VigorBuy Spreadsheet Resource Platform — professional templates, guides, and productivity solutions.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://vigorbuyspread.cyou/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <ComparisonSection />
        <SolutionsSection />
        <TrustSection />
        <FAQSection />
        <ArticleTeaser />
      </main>
      <Footer />
    </>
  );
}